import { useEffect, useState } from 'react';

type ToastProps = {
  message: string;
  duration?: number;
  onClose: () => void;
};

const Toast = ({ message, duration = 3000, onClose }: ToastProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);

    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
    >
      <div className="bg-surface-secondary border border-surface-separator rounded-lg px-6 py-3 shadow-lg">
        <p className="text-sm text-content-primary">{message}</p>
      </div>
    </div>
  );
};

export const useToast = () => {
  const [toast, setToast] = useState<{ message: string } | null>(null);

  const showToast = (message: string) => {
    setToast({ message });
  };

  const hideToast = () => {
    setToast(null);
  };

  const ToastComponent = toast ? <Toast message={toast.message} onClose={hideToast} /> : null;

  return { showToast, ToastComponent };
};
